import React from "react";

const Guidlines = () => {
  return (
    <div className="w-full">
      {/* Shipping Details */}
      <div className=" w-full ">
        <p className="text-start font-['Roboto'] text-black text-lg">
          If one sincerely worships Radha and Krishna in Purushottam month, he
          will attain everything. One who observes Purushottam Vrata, will burn
          up the reactions of all his bad karma and attain the direct service of
          Radha and Krishna.Purushottam month is the best month for all
          spiritual advancement because Krishna overlooks all the
          aparadhas/offenses.
          <br />
          <br />
          Lord Krishna states one who perform devotional services by worshiping
          Him, chanting the Hare Krishna Maha-mantra, by studying Bhagavad-Gita
          & Srimad-Bhagavatam, by giving in charity & by offering ghee lamp to
          Sri Sri Radha-Krishna pleases Him the most.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Purushottam Month Guidelines To Please Krishna-
        </p>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Waking up during Brhma Muhurat or at least by 6 am
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Bathing in holy river if not possible at least one chants Ganga,
            Ganga, Ganga three times
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Eat food without onion and garlic and which is offered to Lord
            Krishna
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Daily offer ghee lamp to Sri Sri Radha Krishna
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Chant at least two rounds of maha-mantra (Hare Krishna Hare Krishna
            Krishna Krishna Hare Hare, Hare Rama Hare Rama Rama Rama Hare Hare)
            on chanting beads. Ideal is to chant sixteen rounds
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Hearing or reading pastime of Lord Krishna for at least 20 minutes
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Sing songs which specifically glorify Lord Krishna
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Take a vow not to criticize any devotee or any scriptures
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Perform Tulsi arati and circumambulate her four times
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Share information about Purushottam Month with other and enthuse
            them to observe Purushottam Month
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Recite Chapter 15 of Bhagavad–Gita, The Purushottam Yoga
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Guidlines;
